import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  root: {
    cursor: 'pointer',
    borderStyle: {
      xs: 'solid',
      md: 'none',
    },
    borderColor: {
      xs: 'border.dark',
      md: 'none',
    },
    borderWidth: {
      xs: '1px',
      md: 'none',
    },
    borderRadius: {
      xs: '16px',
      md: 'none',
    },
    padding: {
      xs: '24px 32px',
      sm: 'none',
    },
    textDecoration: 'none',
  },

  iconWrapper: {
    display: { xs: 'block', md: 'none' },
  },
  imageWrapper: {
    width: '100%',
    bgcolor: '#F9FAFB',
    borderRadius: 3,
    overflow: 'hidden',
    px: 2,
    pt: 2,
    marginBottom: '-100px',
    display: {
      md: 'block',
      xs: 'none',
    },
  },
  textSection: {
    maxWidth: 600,
  },

  image: {
    minHeight: '250px',
    width: '100%',
    transition: 'all 0.3s ease-in-out',
  },

  action: {
    display: 'flex',
    alignItems: 'center',
    color: 'text.primary',
    fontWeight: 600,
  },
  heading: {},
  description: {},
})

export type StylesClassNames = StylesClasses<typeof styles>
export default styles
